/* global globalThis */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useApplication } from '../services/application';
import { AmplifyAuth } from '../services/amplifyAuth';
import { ROUTE_SIGNIN } from '../constants';

export default function useLogout() {
  const history = useHistory();
  const application = useApplication();

  return React.useCallback(
    async (forceRedirect) => {
      try {
        await AmplifyAuth.signOut();
        await application.authorize(undefined, false);
      } catch (error) {
        // Do not localStorage.clear() here: that wipes Cognito device keys and
        // MFA "remember this device" trust. Recover by sending the user to sign-in.
        console.warn(error);
        globalThis.location.assign(ROUTE_SIGNIN.path);
        return;
      }

      try {
        globalThis.Beacon?.('destroy');
      } catch (error) {
        console.warn(error);
      }

      if (forceRedirect) {
        history?.push(ROUTE_SIGNIN.path);
      }
    },
    [history, application]
  );
}
